module.exports = __webpack_public_path__ + "img/4.bf686e55.jpg";